import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '正版授权',
      desc: '所有漫画均获得官方正版授权，支持原创作者，享受高清画质阅读体验。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      desc: '手机、平板、电脑无缝切换，阅读进度实时同步，随时随地继续追更。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载',
      desc: '采用智能预加载技术，翻页零等待，为你带来流畅顺滑的阅读感受。',
    },
    {
      icon: 'ri-calendar-check-line',
      title: '每日更新',
      desc: '海量漫画每日准时更新，热门连载第一时间同步上架，追更快人一步。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            为什么选择 yy漫画？
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            用心打造最好的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20anime-style%20illustration%20with%20soft%20golden%20light%2C%20open%20books%20and%20floating%20manga%20pages%20with%20gentle%20magical%20glow%2C%20cozy%20reading%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20dreamy%20bokeh%20effect%2C%20peaceful%20composition&width=1800&height=600&seq=yy-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
          准备好开启你的漫画之旅了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-50/80 leading-relaxed">
          加入千万漫迷的行列，在 yy漫画发现属于你的精彩故事。每日更新，正版授权，畅享阅读！
        </p>
        <Link
          to="/category/lianai"
          className="inline-block mt-8 px-10 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          立即免费阅读
        </Link>
      </div>
    </section>
  );
}